// Todo: proxy기능을 이용해서 다시 코딩하기

import axios from 'axios'
// import oh from '@/lib/object_helper'
// import { ACCESS_TOKEN_KEY } from '@/lib/constants'
import STATUS_CODE from '@/lib/constants'
import URLS from '@/lib/urls'
// import eventHub from './eventhub'

// const BASE_API_URL = '/api'

class Request {

  // static before_request (config) {
  //   // let params = (config.params) ? JSON.stringify(config.params) : ''
  //   // console.log('before_request', `[${config.method}] ${config.url} ${params}`)
  //   // config.params를 받을수 있음
  //
  //   const token_string = localStorage.getItem(ACCESS_TOKEN_KEY)
  //   if (token_string) {
  //     config.headers['x-mdsqr-auth'] = token_string;
  //   }
  //
  //   eventHub.$emit('spinner', true)
  //   return config;
  // }

  // static after_respnse (response) {
  //
  //   let {config, data} = response
  //   let method = (config.method && config.method.toLowerCase())
  //   let req_data = config.data
  //
  //   if (method === 'post' || method === 'put' || method === 'patch') {
  //     if (req_data instanceof FormData) {
  //       console.log('API *REQ', `[${config.method}-FormData] ${config.url}`, [...req_data.entries()])
  //     } else {
  //       if (!req_data) req_data = {}
  //       console.log('API *REQ', `[${config.method}] ${config.url}`, JSON.parse(req_data))
  //     }
  //   } else {
  //     // let params = (config.params) ? JSON.stringify(config.params) : ''
  //     console.log('API *REQ', `[${config.method}] ${config.url}`, config.params)
  //   }
  //   console.log('API *RES', data)
  //   if ( data.status > 300) alert(`${config.url}\n${data.msg}`)
  //   eventHub.$emit('spinner', false)
  //   return response
  // }

  static get_axios () {

    const instance = axios.create({
      baseURL: URLS.API,
      timeout: 30000, //5초에서 30초로 늘림 kjw 20190529
      headers: {'Accept': 'application/json'},
      validateStatus: function (status) {
        return status >= 200 && status < 300; // default
      },
      // 이걸 건드리면 자동으로 JSON.parse가 되지 않는다.
      // transformRequest: [function (data, headers) {
      //   // Do whatever you want to transform the data
      //   return data;
      // }],
      // transformResponse: [function (data) {
      //   // Do whatever you want to transform the data
      //   return data;
      // }]
    })
    instance.interceptors.request.use(Request.before_request, function (error) {
      return Promise.reject(error);
    });

    instance.interceptors.response.use(Request.after_respnse, function (error) {
      return Promise.reject(error);
    })

    return instance;
  }
}

export default Request.get_axios()
